import { iconFactory } from '../iconFactory'

export const Crown = iconFactory(
  'Crown',
  ({ fill }) => (
    <>
      <circle cx="12" cy="6" r="1" fill={fill} />
      <circle cx="4" cy="7" r="1" fill={fill} />
      <circle cx="20" cy="7" r="1" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.90828 18.8C6.93072 18.8 6.0964 18.0933 5.93554 17.1291L4.71732 9.82654C4.64156 9.37236 5.16802 9.06588 5.52556 9.35602L8.98392 12.1624C9.20891 12.3449 9.54149 12.2986 9.70807 12.0616L11.5909 9.38217C11.79 9.0988 12.21 9.0988 12.4091 9.38217L14.2919 12.0616C14.4585 12.2986 14.7911 12.3449 15.0161 12.1624L18.4744 9.35602C18.832 9.06588 19.3584 9.37236 19.2827 9.82654L18.0645 17.1291C17.9036 18.0933 17.0693 18.8 16.0917 18.8H7.90828Z"
        fill={fill}
      />
    </>
  ),
  { viewBox: '0 0 24 24', height: '24px', width: '24px' },
)
